import axios from 'axios';
import { getAccessToken } from 'Utils/auth';
import { APIUrl } from 'Utils/Utils';

export type TurnRating = 'up' | 'down';

interface TurnFeedbackPayload {
  turn_id: string;
  session_id: string;
  chat_response_rating: TurnRating;
  feedback_defined_phrases: string[];
  custom_feedback: string | null;
}

interface ContactUsPayload {
  request_type: string;
  message: string;
}

export const chatFeedbackApi = {
  submitTurnFeedback: async (payload: TurnFeedbackPayload): Promise<void> => {
    const token = await getAccessToken();
    await axios.post(`${APIUrl()}/feedback/turn_feedback`, payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  },

  submitContactUs: async (payload: ContactUsPayload): Promise<void> => {
    const token = await getAccessToken();
    await axios({
      method: 'POST',
      headers: {
        'access-control-allow-origin': '*',
        'content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: payload,
      url: `${APIUrl()}/feedback/contact_us`,
    });
  },
};
